var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M4.875 14.25V7.375M1.75 8.625V13C1.75 13.6904 2.30964 14.25 3 14.25H11.3914C12.3168 14.25 13.1039 13.5748 13.2446 12.6601L13.9177 8.28511C14.0924 7.14931 13.2136 6.125 12.0645 6.125H9.875C9.52982 6.125 9.25 5.84518 9.25 5.5V3.29115C9.25 2.44 8.56 1.75 7.70885 1.75C7.50584 1.75 7.32186 1.86956 7.23941 2.05508L5.03996 7.00384C4.93965 7.22954 4.71582 7.375 4.46883 7.375H3C2.30964 7.375 1.75 7.93464 1.75 8.625Z",
    stroke: "#676A73",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/Thumbs_Up_Icon.ecc9f89a93b16b41c475500e0b265fa8.svg";
export { ForwardRef as ReactComponent };